import { render } from "./CandidatureSaved.vue?vue&type=template&id=6d0bf6ca"
import script from "./CandidatureSaved.vue?vue&type=script&lang=js"
export * from "./CandidatureSaved.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Dashboard/Type/CandidatureSaved.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6d0bf6ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6d0bf6ca', __exports__)) {
    api.reload('6d0bf6ca', __exports__)
  }
  
  module.hot.accept("./CandidatureSaved.vue?vue&type=template&id=6d0bf6ca", () => {
    api.rerender('6d0bf6ca', render)
  })

}


export default __exports__